import get from 'lodash/get';
import { SIGNAL } from '../helpers/constants';
import { ReduxEmitter } from '../helpers/reduxEmitter';
import { trackAppAction } from '../../../utils/sentry/sentryMethods';

export class OTSignal extends ReduxEmitter {
  static handleProviderJoin = () => {};

  static handleProviderFinishCall = () => {};

  constructor({ dispatch, otSession }) {
    super(dispatch);
    this.otSession = otSession;
  }

  get session() {
    if (!this.otSession || !this.otSession.session) {
      console.warn('[ot-signal] no session');
      return null;
    }

    return this.otSession.session;
  }

  // Use for connectionRoom p2p
  handleVisitDuration = data => {
    if (!data) return;
    this.dispatchSetConnectionTime(data);
  };

  // Use for Virtual and Urgent Visit
  handleSetDurationData = data => {
    if (!data) return;
    this.dispatchSetDurationData(data);
  };

  handlePendingInvitations = data => {
    if (!data) return;
    this.dispatchUpdateInvitations(data);
  };

  handleSignal = event => {
    switch (event.type) {
      case SIGNAL.VISIT_DURATION: {
        console.log('[ot-signal] p2p visit duration', event.data);
        this.handleVisitDuration(event.data);
        break;
      }
      case SIGNAL.VISIT_METADATA: {
        const { data } = event;
        console.log('[ot-signal] visit metadata', data);
        this.handleSetDurationData(data);
        break;
      }
      case SIGNAL.PENDING_INVITATIONS: {
        console.log('[ot-signal] invitation signal', event.data);
        this.handlePendingInvitations(event.data);
        break;
      }
      case SIGNAL.PROVIDER_CONNECTED: {
        console.info('[ot-signal] =============PROVIDER CONNECTED===========');
        trackAppAction('[ot-signal] provider connected');
        OTSignal.handleProviderJoin();
        break;
      }
      case SIGNAL.VISIT_ENDED: {
        const { data } = event;
        console.info('[ot-signal] =============END VISIT ===========', data);
        trackAppAction(`[ot-signal] end visit: ${get(data, 'status')}`);
        OTSignal.handleProviderFinishCall(get(data, 'status'));
        break;
      }
      default:
        break;
    }
  };

  setupListeners() {
    if (!this.session) return;
    console.log('[ot-signal] setup listeners');

    this.session.on('signal', this.handleSignal);
  }

  clearListeners() {
    if (!this.session) return;
    console.log('[ot-signal] clear listeners');
    this.session.off('signal', this.handleSignal);
  }

  init() {
    this.setupListeners();
  }

  destroy() {
    this.clearListeners();
    console.info('[ot-signal] destroyed signal');
  }
}



// WEBPACK FOOTER //
// ./src/redux/opentok/core/signal.js